function validate(phoneNumber: string) {
  // Expressão regular para validar formatos:
  // (xx) xxxx-xxxx   -> telefone fixo
  // (xx) 9xxxx-xxxx  -> telefone celular
  const regexFixo = /^\(\d{2}\)\s?\d{4}-\d{4}$/;
  const regexCelular = /^\(\d{2}\)\s?9\d{4}-\d{4}$/;

  // Remove todos os caracteres não numéricos
  const telefoneNumerico = phoneNumber.replace(/\D/g, "");

  // Valida se tem 10 (fixo) ou 11 (celular) dígitos
  const isTamanhoValido = telefoneNumerico.length === 10 || telefoneNumerico.length === 11;

  // Valida o formato com regex
  const isFormatoValido = regexFixo.test(phoneNumber) || regexCelular.test(phoneNumber);

  // Retorna verdadeiro apenas se ambos forem válidos
  return isTamanhoValido && isFormatoValido;
}

const cellphoneValidator = {
  validate
}

export default cellphoneValidator;
